import type { TSimulacaoGrupoParcelaMensais } from '@/features/simulador/shared/domain/schemas/simulacao-grupo-parcela.schema'

export class CalculadoraGrupoParcelasMensais {
  static readonly totalParcelas = (mensais: TSimulacaoGrupoParcelaMensais) => {
    return mensais.reduce((total, mensal) => total + mensal.quantidade, 0)
  }

  static readonly maiorValor = (mensais: TSimulacaoGrupoParcelaMensais) => {
    return mensais.reduce((maior, atual) => Math.max(atual.valor, maior), 0)
  }
}
